import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import 'styled-components/macro'
import Step from '@material-ui/core/Step'
import MobileStepper from '@material-ui/core/MobileStepper'
import { FlexContainer } from 'heliocor-ui'
import isEmpty from 'lodash/isEmpty'

import { StepperStyled, StepperBlock, StepperButton } from './styles'
import { SaveAndReset } from './StepperExtras'
import useTimeout from '../../hooks/useTimeout'

const StepperWizard = ({ activeStep, goToStep, steps, saveDataToStore, cleanErrors, errors, isMobile, setStepHasError, handleNext, showKYCTypeStep }) => {

    const { t } = useTranslation()
    const authenticated = useSelector(state => state.config.authenticated)
    const cafeStatus = useSelector(state => state.general.cafeStatus)
    const isRequest = useSelector(state => state.config.isRequest)
    const completedSteps = useSelector(state => state.navigation.completedSteps)
    const customColors = useSelector(store => store.settings.colors)
    const stepIndex = useSelector(store => store.navigation.stepIndex)
    const postErrors = useSelector(store => store.party.postErrors)

    const formSubmitted = cafeStatus === 'SUBMITTED'

    //TODO: Check this shit, I don't like it
    useTimeout(() => {
        if (completedSteps.includes(stepIndex) && !isEmpty(errors)) {
            setStepHasError(stepIndex)
        }
    }, 500)

    const moveToStep = (index, step) => {
        if (index < activeStep || isRequest) {
            cleanErrors()
            goToStep(index)
        } else {
            handleNext({index})
        }
    }

    const SelectedStepper = isMobile ? MobileStepper : StepperStyled
    const stepperProps = isMobile
        ? { variant: 'progress', steps: steps.length, activeStep, position: 'static' }
        : { activeStep, orientation: 'vertical' }
    
    const isStepDisabled = index => {
        if (index === 0 || formSubmitted || activeStep === index || (index > activeStep && (!isEmpty(errors) || postErrors?.length)) || (index === 1 && showKYCTypeStep)) return true

        if (index < activeStep) return false

        const lastCompleted = Math.max(...completedSteps)

        if (lastCompleted === index - 1) return false

        if (!completedSteps.includes(index)) return true
            
        return false
    }

    const isStepCompleted = index =>
        (authenticated && index === 0)
        || (index !== activeStep && completedSteps.includes(index))
        || formSubmitted

    return (
        <FlexContainer column height='inherit'>
            <StepperBlock backgroundColor={customColors?.stepperBackground} column height='100%' data-cy="stepper">
                <SelectedStepper {...stepperProps}>
                    {steps.map((step, index) => (
                        <Step key={index}>
                            <StepperButton
                                {...(index === 0) && { icon: ' ' }}
                                completed={isStepCompleted(index)}
                                onClick={() => moveToStep(index, step.id)}
                                disabled={isStepDisabled(index)}
                                setGreyBg={(index > activeStep)}
                                data-cy={step.title || step.id}
                            >
                                {(!isMobile || steps.length === 1) &&
                                    <span css={isMobile && steps.length === 1 && 'padding-left: .5rem'}>
                                        {t(step.title || step.id)}
                                    </span>
                                }
                            </StepperButton>
                        </Step>
                    ))}
                </SelectedStepper>
                {(authenticated && !formSubmitted && !isRequest && !isMobile) &&
                    <SaveAndReset saveDataToStore={saveDataToStore} />
                }
            </StepperBlock>
        </FlexContainer>
    )
}

export default StepperWizard